import { APP_CONFIG } from '@/config/app';

const DEFAULT_LOCALE = 'es';
const DEFAULT_VIEW = 'home';

export const CMS_CONTAINER_CONFIG = {
  GPTEST: {
    locale: DEFAULT_LOCALE,
    views: {
      home: [
        {
          key: 'carousel-main',
          type: 'carousel',
          code: 'gptest-home-main',
          priority: 'critical',
        },
        {
          key: 'lobby-featured',
          type: 'lobby',
          lobbyCode: 'gptest-featured',
          page: 1,
          limit: 24,
          priority: 'critical',
        },
        {
          key: 'announcements-main',
          type: 'announcement',
          priority: 'critical',
        },
        {
          key: 'lobby-slots',
          type: 'lobby',
          lobbyCode: 'gptest-slots',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-live',
          type: 'lobby',
          lobbyCode: 'gptest-live',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-virtual',
          type: 'lobby',
          lobbyCode: 'gptest-virtual',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-crash-instant',
          type: 'lobby',
          lobbyCode: 'gptest-crash-instant',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-new',
          type: 'lobby',
          lobbyCode: 'gptest-new',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-roulette',
          type: 'lobby',
          lobbyCode: 'gptest-roulette',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-table-classics',
          type: 'lobby',
          lobbyCode: 'gptest-table-classics',
          page: 1,
          limit: 24,
        },
        {
          key: 'carousel-secondary',
          type: 'carousel',
          code: 'gptest-home-secondary',
        },
      ],
      games: [
        {
          key: 'announcements-games',
          type: 'announcement',
          priority: 'critical',
        },
        {
          key: 'carousel-games-main',
          type: 'carousel',
          code: 'gptest-home-secondary',
          priority: 'critical',
        },
        {
          key: 'lobby-featured',
          type: 'lobby',
          lobbyCode: 'gptest-featured',
          page: 1,
          limit: 48,
          priority: 'critical',
        },
        {
          key: 'lobby-slots',
          type: 'lobby',
          lobbyCode: 'gptest-slots',
          page: 1,
          limit: 48,
          priority: 'critical',
        },
        {
          key: 'lobby-live',
          type: 'lobby',
          lobbyCode: 'gptest-live',
          page: 1,
          limit: 48,
        },
        {
          key: 'lobby-virtual',
          type: 'lobby',
          lobbyCode: 'gptest-virtual',
          page: 1,
          limit: 48,
        },
        {
          key: 'lobby-crash-instant',
          type: 'lobby',
          lobbyCode: 'gptest-crash-instant',
          page: 1,
          limit: 48,
        },
        {
          key: 'lobby-new',
          type: 'lobby',
          lobbyCode: 'gptest-new',
          page: 1,
          limit: 48,
        },
        {
          key: 'lobby-roulette',
          type: 'lobby',
          lobbyCode: 'gptest-roulette',
          page: 1,
          limit: 48,
        },
        {
          key: 'lobby-table-classics',
          type: 'lobby',
          lobbyCode: 'gptest-table-classics',
          page: 1,
          limit: 48,
        },
        {
          key: 'carousel-games-campaign',
          type: 'carousel',
          code: 'gptest-home-campaign',
        },
      ],
      lobby: [
        {
          key: 'lobby-featured',
          type: 'lobby',
          lobbyCode: 'gptest-featured',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-slots',
          type: 'lobby',
          lobbyCode: 'gptest-slots',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-live',
          type: 'lobby',
          lobbyCode: 'gptest-live',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-virtual',
          type: 'lobby',
          lobbyCode: 'gptest-virtual',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-crash-instant',
          type: 'lobby',
          lobbyCode: 'gptest-crash-instant',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-new',
          type: 'lobby',
          lobbyCode: 'gptest-new',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-roulette',
          type: 'lobby',
          lobbyCode: 'gptest-roulette',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-table-classics',
          type: 'lobby',
          lobbyCode: 'gptest-table-classics',
          page: 1,
          limit: 24,
        },
      ],
    },
  },
  ASD: {
    locale: DEFAULT_LOCALE,
    views: {
      home: [
        {
          key: 'carousel-main',
          type: 'carousel',
          code: 'asd-home-main',
          priority: 'critical',
        },
        {
          key: 'lobby-featured',
          type: 'lobby',
          lobbyCode: 'asd-featured',
          page: 1,
          limit: 24,
          priority: 'critical',
        },
        {
          key: 'announcements-main',
          type: 'announcement',
          priority: 'critical',
        },
        {
          key: 'lobby-slots',
          type: 'lobby',
          lobbyCode: 'asd-slots',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-new',
          type: 'lobby',
          lobbyCode: 'asd-new',
          page: 1,
          limit: 24,
        },
        {
          key: 'carousel-secondary',
          type: 'carousel',
          code: 'asd-home-secondary',
        },
      ],
      games: [
        {
          key: 'announcements-games',
          type: 'announcement',
          priority: 'critical',
        },
        {
          key: 'carousel-games-main',
          type: 'carousel',
          code: 'asd-home-secondary',
          priority: 'critical',
        },
        {
          key: 'lobby-featured',
          type: 'lobby',
          lobbyCode: 'asd-featured',
          page: 1,
          limit: 48,
          priority: 'critical',
        },
        {
          key: 'lobby-slots',
          type: 'lobby',
          lobbyCode: 'asd-slots',
          page: 1,
          limit: 48,
          priority: 'critical',
        },
        {
          key: 'lobby-new',
          type: 'lobby',
          lobbyCode: 'asd-new',
          page: 1,
          limit: 48,
        },
        {
          key: 'carousel-games-campaign',
          type: 'carousel',
          code: 'asd-home-campaign',
        },
      ],
      lobby: [
        {
          key: 'lobby-featured',
          type: 'lobby',
          lobbyCode: 'asd-featured',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-slots',
          type: 'lobby',
          lobbyCode: 'asd-slots',
          page: 1,
          limit: 24,
        },
        {
          key: 'lobby-new',
          type: 'lobby',
          lobbyCode: 'asd-new',
          page: 1,
          limit: 24,
        },
      ],
    },
  },
};

export const getOperatorCmsConfig = (operator = APP_CONFIG.operator, view = DEFAULT_VIEW) => {
  const normalizedOperator = String(operator || APP_CONFIG.operator).trim().toUpperCase();
  const normalizedView = String(view || DEFAULT_VIEW).trim().toLowerCase();
  const operatorConfig = CMS_CONTAINER_CONFIG[normalizedOperator] || CMS_CONTAINER_CONFIG.GPTEST;

  const viewContainers = operatorConfig?.views?.[normalizedView]
    || operatorConfig?.views?.[DEFAULT_VIEW]
    || [];

  return {
    ...operatorConfig,
    view: normalizedView,
    containers: viewContainers,
  };
};
